// extracted by mini-css-extract-plugin
export default {"Content":"Layout_Content__hg49G"};